"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenForUpdates = void 0;
const retrommo_types_1 = require("retrommo-types");
const ItemInstance_1 = require("../../classes/ItemInstance");
const MainMenuCharacter_1 = require("../../classes/MainMenuCharacter");
const NPC_1 = require("../../classes/NPC");
const Party_1 = require("../../classes/Party");
const Player_1 = require("../../classes/Player");
const Quest_1 = require("../../classes/Quest");
const pixel_pigeon_1 = require("pixel-pigeon");
const WorldCharacter_1 = require("../../classes/WorldCharacter");
const state_1 = require("../../state");
const addWorldCharacterMarker_1 = require("../addWorldCharacterMarker");
const canWorldCharacterTurnInQuest_1 = require("../canWorldCharacterTurnInQuest");
const clearWorldCharacterMarker_1 = require("../clearWorldCharacterMarker");
const closeWorldMenus_1 = require("../world-menus/closeWorldMenus");
const createBattleState_1 = require("../state/createBattleState");
const createMainMenuState_1 = require("../state/main-menu/createMainMenuState");
const createWorldState_1 = require("../state/createWorldState");
const definables_1 = require("definables");
const emotesWorldMenu_1 = require("../../world-menus/emotesWorldMenu");
const exitWorldCharacters_1 = require("../exitWorldCharacters");
const getWorldState_1 = require("../state/getWorldState");
const inventoryWorldMenu_1 = require("../../world-menus/inventoryWorldMenu");
const listenForMainMenuUpdates_1 = require("./main-menu/listenForMainMenuUpdates");
const listenForWorldUpdates_1 = require("./listenForWorldUpdates");
const loadItemInstanceUpdate_1 = require("../load-updates/loadItemInstanceUpdate");
const loadPartyUpdate_1 = require("../load-updates/loadPartyUpdate");
const loadWorldCharacterUpdate_1 = require("../load-updates/loadWorldCharacterUpdate");
const loadWorldNPCUpdate_1 = require("../load-updates/loadWorldNPCUpdate");
const loadWorldPartyCharacterUpdate_1 = require("../load-updates/loadWorldPartyCharacterUpdate");
const npcDialogueWorldMenu_1 = require("../../world-menus/npcDialogueWorldMenu");
const questLogWorldMenu_1 = require("../../world-menus/questLogWorldMenu");
const resetParty_1 = require("../resetParty");
const selectWorldCharacter_1 = require("../selectWorldCharacter");
const selectedPlayerWorldMenu_1 = require("../../world-menus/selectedPlayerWorldMenu");
const spellbookWorldMenu_1 = require("../../world-menus/spellbookWorldMenu");
const statsWorldMenu_1 = require("../../world-menus/statsWorldMenu");
const listenForUpdates = () => {
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "add-player",
        onMessage: (update) => {
            new Player_1.Player({
                id: update.playerID,
                userID: update.userID,
                username: update.username,
            });
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "end-player-battle",
        onMessage: (update) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (typeof update.character !== "undefined") {
                const worldState = (0, createWorldState_1.createWorldState)({
                    agility: update.character.agility,
                    bagItemInstanceIDs: update.character.bagItemInstances.map((bagItemInstance) => bagItemInstance.itemInstanceID),
                    bodyItemInstanceID: (_a = update.character.bodyItemInstance) === null || _a === void 0 ? void 0 : _a.itemInstanceID,
                    boostItemInstanceIDs: update.character.boostItemInstances.map((boostItemInstance) => boostItemInstance.itemInstanceID),
                    clothesDyeItemInstanceID: (_b = update.character.clothesDyeItemInstance) === null || _b === void 0 ? void 0 : _b.itemInstanceID,
                    defense: update.character.defense,
                    experienceUntilLevel: update.character.experienceUntilLevel,
                    hairDyeItemInstanceID: (_c = update.character.hairDyeItemInstance) === null || _c === void 0 ? void 0 : _c.itemInstanceID,
                    headItemInstanceID: (_d = update.character.headItemInstance) === null || _d === void 0 ? void 0 : _d.itemInstanceID,
                    intelligence: update.character.intelligence,
                    inventoryGold: update.character.inventoryGold,
                    luck: update.character.luck,
                    mainHandItemInstanceID: (_e = update.character.mainHandItemInstance) === null || _e === void 0 ? void 0 : _e.itemInstanceID,
                    maskItemInstanceID: (_f = update.character.maskItemInstance) === null || _f === void 0 ? void 0 : _f.itemInstanceID,
                    offHandItemInstanceID: (_g = update.character.offHandItemInstance) === null || _g === void 0 ? void 0 : _g.itemInstanceID,
                    outfitItemInstanceID: (_h = update.character.outfitItemInstance) === null || _h === void 0 ? void 0 : _h.itemInstanceID,
                    strength: update.character.strength,
                    timePlayed: update.character.timePlayed,
                    wisdom: update.character.wisdom,
                    worldCharacterID: update.character.characterID,
                });
                state_1.state.setValues({
                    battleState: null,
                    worldState,
                });
                for (const worldCharacterUpdate of update.character.characters) {
                    (0, loadWorldCharacterUpdate_1.loadWorldCharacterUpdate)(worldCharacterUpdate);
                    const worldCharacterUpdatePlayer = (0, definables_1.getDefinable)(Player_1.Player, worldCharacterUpdate.playerID);
                    worldCharacterUpdatePlayer.worldCharacterID =
                        worldCharacterUpdate.characterID;
                }
                for (const worldPartyUpdate of update.character.parties) {
                    (0, loadPartyUpdate_1.loadPartyUpdate)(worldPartyUpdate);
                }
                for (const worldNPCUpdate of update.character.npcs) {
                    (0, loadWorldNPCUpdate_1.loadWorldNPCUpdate)(worldNPCUpdate);
                }
                for (const bagItemInstanceUpdate of update.character.bagItemInstances) {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(bagItemInstanceUpdate);
                }
                for (const boostItemInstanceUpdate of update.character
                    .boostItemInstances) {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(boostItemInstanceUpdate);
                }
                if (typeof update.character.bodyItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.bodyItemInstance);
                }
                if (typeof update.character.headItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.headItemInstance);
                }
                if (typeof update.character.mainHandItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.mainHandItemInstance);
                }
                if (typeof update.character.offHandItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.offHandItemInstance);
                }
                if (typeof update.character.clothesDyeItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.clothesDyeItemInstance);
                }
                if (typeof update.character.hairDyeItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.hairDyeItemInstance);
                }
                if (typeof update.character.maskItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.maskItemInstance);
                }
                if (typeof update.character.outfitItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.outfitItemInstance);
                }
                (0, selectWorldCharacter_1.selectWorldCharacter)(update.character.characterID);
                if (state_1.state.values.selectedPlayerID !== null) {
                    selectedPlayerWorldMenu_1.selectedPlayerWorldMenu.open({});
                }
            }
            for (const playerUpdate of update.players) {
                const player = (0, definables_1.getDefinable)(Player_1.Player, playerUpdate.playerID);
                player.character.level = playerUpdate.level;
            }
            if (typeof update.world !== "undefined") {
                for (const worldCharacterUpdate of update.world.characters) {
                    (0, loadWorldCharacterUpdate_1.loadWorldCharacterUpdate)(worldCharacterUpdate);
                    const worldCharacterUpdatePlayer = (0, definables_1.getDefinable)(Player_1.Player, worldCharacterUpdate.playerID);
                    worldCharacterUpdatePlayer.worldCharacterID =
                        worldCharacterUpdate.characterID;
                    if (state_1.state.values.selectedPlayerID === worldCharacterUpdatePlayer.id) {
                        (0, addWorldCharacterMarker_1.addWorldCharacterMarker)(worldCharacterUpdatePlayer.worldCharacterID, retrommo_types_1.MarkerType.Selected);
                    }
                }
                for (const worldPartyUpdate of update.world.parties) {
                    (0, loadPartyUpdate_1.loadPartyUpdate)(worldPartyUpdate);
                }
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "enter-player",
        onMessage: (update) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const player = (0, definables_1.getDefinable)(Player_1.Player, update.playerID);
            player.character = {
                classID: update.classID,
                level: update.level,
                partyID: update.partyID,
            };
            const party = new Party_1.Party({
                id: update.partyID,
            });
            party.playerIDs = [update.playerID];
            if (typeof update.characterID !== "undefined") {
                player.worldCharacterID = update.characterID;
            }
            if (typeof update.world !== "undefined") {
                (0, loadWorldCharacterUpdate_1.loadWorldCharacterUpdate)(update.world.character);
            }
            if (typeof update.character !== "undefined") {
                (0, definables_1.getDefinables)(MainMenuCharacter_1.MainMenuCharacter).forEach((mainMenuCharacter) => {
                    mainMenuCharacter.remove();
                });
                state_1.state.setValues({
                    mainMenuState: null,
                    worldState: (0, createWorldState_1.createWorldState)({
                        agility: update.character.agility,
                        bagItemInstanceIDs: update.character.bagItemInstances.map((itemInstanceUpdate) => itemInstanceUpdate.itemInstanceID),
                        bodyItemInstanceID: (_a = update.character.bodyItemInstance) === null || _a === void 0 ? void 0 : _a.itemInstanceID,
                        boostItemInstanceIDs: update.character.boostItemInstances.map((itemInstanceUpdate) => itemInstanceUpdate.itemInstanceID),
                        clothesDyeItemInstanceID: (_b = update.character.clothesDyeItemInstance) === null || _b === void 0 ? void 0 : _b.itemInstanceID,
                        defense: update.character.defense,
                        experienceUntilLevel: update.character.experienceUntilLevel,
                        hairDyeItemInstanceID: (_c = update.character.hairDyeItemInstance) === null || _c === void 0 ? void 0 : _c.itemInstanceID,
                        headItemInstanceID: (_d = update.character.headItemInstance) === null || _d === void 0 ? void 0 : _d.itemInstanceID,
                        intelligence: update.character.intelligence,
                        inventoryGold: update.character.inventoryGold,
                        luck: update.character.luck,
                        mainHandItemInstanceID: (_e = update.character.mainHandItemInstance) === null || _e === void 0 ? void 0 : _e.itemInstanceID,
                        maskItemInstanceID: (_f = update.character.maskItemInstance) === null || _f === void 0 ? void 0 : _f.itemInstanceID,
                        offHandItemInstanceID: (_g = update.character.offHandItemInstance) === null || _g === void 0 ? void 0 : _g.itemInstanceID,
                        outfitItemInstanceID: (_h = update.character.outfitItemInstance) === null || _h === void 0 ? void 0 : _h.itemInstanceID,
                        strength: update.character.strength,
                        timePlayed: update.character.timePlayed,
                        wisdom: update.character.wisdom,
                        worldCharacterID: update.character.characterID,
                    }),
                });
                for (const worldCharacterUpdate of update.character.characters) {
                    (0, loadWorldCharacterUpdate_1.loadWorldCharacterUpdate)(worldCharacterUpdate);
                    const worldCharacterUpdatePlayer = (0, definables_1.getDefinable)(Player_1.Player, worldCharacterUpdate.playerID);
                    worldCharacterUpdatePlayer.worldCharacterID =
                        worldCharacterUpdate.characterID;
                }
                for (const worldPartyUpdate of update.character.parties) {
                    (0, loadPartyUpdate_1.loadPartyUpdate)(worldPartyUpdate);
                }
                for (const worldNPCUpdate of update.character.npcs) {
                    (0, loadWorldNPCUpdate_1.loadWorldNPCUpdate)(worldNPCUpdate);
                }
                for (const bagItemInstanceUpdate of update.character.bagItemInstances) {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(bagItemInstanceUpdate);
                }
                for (const boostItemInstanceUpdate of update.character
                    .boostItemInstances) {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(boostItemInstanceUpdate);
                }
                if (typeof update.character.bodyItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.bodyItemInstance);
                }
                if (typeof update.character.headItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.headItemInstance);
                }
                if (typeof update.character.mainHandItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.mainHandItemInstance);
                }
                if (typeof update.character.offHandItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.offHandItemInstance);
                }
                if (typeof update.character.clothesDyeItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.clothesDyeItemInstance);
                }
                if (typeof update.character.hairDyeItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.hairDyeItemInstance);
                }
                if (typeof update.character.maskItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.maskItemInstance);
                }
                if (typeof update.character.outfitItemInstance !== "undefined") {
                    (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.character.outfitItemInstance);
                }
                (0, selectWorldCharacter_1.selectWorldCharacter)(update.character.characterID);
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "exit-player",
        onMessage: (update) => {
            const player = (0, definables_1.getDefinable)(Player_1.Player, update.playerID);
            if (state_1.state.values.selectedPlayerID === update.playerID) {
                selectedPlayerWorldMenu_1.selectedPlayerWorldMenu.close();
            }
            if (player.hasWorldCharacter()) {
                (0, exitWorldCharacters_1.exitWorldCharacters)([player.worldCharacterID]);
                player.character = null;
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "initial-update",
        onMessage: (update) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            for (const mainMenuCharacter of (0, definables_1.getDefinables)(MainMenuCharacter_1.MainMenuCharacter).values()) {
                mainMenuCharacter.remove();
            }
            for (const worldCharacter of (0, definables_1.getDefinables)(WorldCharacter_1.WorldCharacter).values()) {
                worldCharacter.remove();
            }
            for (const party of (0, definables_1.getDefinables)(Party_1.Party).values()) {
                party.remove();
            }
            for (const itemInstance of (0, definables_1.getDefinables)(ItemInstance_1.ItemInstance).values()) {
                itemInstance.remove();
            }
            for (const player of (0, definables_1.getDefinables)(Player_1.Player).values()) {
                player.remove();
            }
            for (const playerUpdate of update.players) {
                new Player_1.Player({
                    character: typeof playerUpdate.character !== "undefined"
                        ? {
                            classID: playerUpdate.character.classID,
                            level: playerUpdate.character.level,
                            partyID: playerUpdate.character.partyID,
                        }
                        : undefined,
                    id: playerUpdate.playerID,
                    userID: playerUpdate.userID,
                    username: playerUpdate.username,
                    worldCharacterID: playerUpdate.characterID,
                });
            }
            for (const partyUpdate of update.parties) {
                (0, loadPartyUpdate_1.loadPartyUpdate)(partyUpdate);
            }
            state_1.state.setValues({
                battleState: null,
                isSubscribed: update.isSubscribed,
                mainMenuState: null,
                selectedPlayerID: null,
                worldState: null,
            });
            switch (update.mainState) {
                case retrommo_types_1.MainState.Battle:
                    state_1.state.setValues({
                        battleState: (0, createBattleState_1.createBattleState)(),
                    });
                    break;
                case retrommo_types_1.MainState.MainMenu: {
                    if (typeof update.mainMenu === "undefined") {
                        throw new Error("Initial update in MainMenu MainState is missing mainMenu.");
                    }
                    const mainMenuCharacterIDs = [];
                    for (const mainMenuCharacterUpdate of update.mainMenu
                        .mainMenuCharacters) {
                        mainMenuCharacterIDs.push(new MainMenuCharacter_1.MainMenuCharacter({
                            classID: mainMenuCharacterUpdate.classID,
                            clothesDyeItemID: mainMenuCharacterUpdate.clothesDyeItemID,
                            figureID: mainMenuCharacterUpdate.figureID,
                            hairDyeItemID: mainMenuCharacterUpdate.hairDyeItemID,
                            id: mainMenuCharacterUpdate.characterID,
                            level: mainMenuCharacterUpdate.level,
                            maskItemID: mainMenuCharacterUpdate.maskItemID,
                            outfitItemID: mainMenuCharacterUpdate.outfitItemID,
                            skinColorID: mainMenuCharacterUpdate.skinColorID,
                        }).id);
                    }
                    state_1.state.setValues({
                        mainMenuState: (0, createMainMenuState_1.createMainMenuState)({ mainMenuCharacterIDs }),
                    });
                    break;
                }
                case retrommo_types_1.MainState.World: {
                    if (typeof update.world === "undefined") {
                        throw new Error("Initial update in World MainState is missing world.");
                    }
                    const worldState = (0, createWorldState_1.createWorldState)({
                        agility: update.world.agility,
                        bagItemInstanceIDs: update.world.bagItemInstances.map((itemInstanceUpdate) => itemInstanceUpdate.itemInstanceID),
                        bodyItemInstanceID: (_a = update.world.bodyItemInstance) === null || _a === void 0 ? void 0 : _a.itemInstanceID,
                        boostItemInstanceIDs: update.world.boostItemInstances.map((itemInstanceUpdate) => itemInstanceUpdate.itemInstanceID),
                        clothesDyeItemInstanceID: (_b = update.world.clothesDyeItemInstance) === null || _b === void 0 ? void 0 : _b.itemInstanceID,
                        defense: update.world.defense,
                        experienceUntilLevel: update.world.experienceUntilLevel,
                        hairDyeItemInstanceID: (_c = update.world.hairDyeItemInstance) === null || _c === void 0 ? void 0 : _c.itemInstanceID,
                        headItemInstanceID: (_d = update.world.headItemInstance) === null || _d === void 0 ? void 0 : _d.itemInstanceID,
                        intelligence: update.world.intelligence,
                        inventoryGold: update.world.inventoryGold,
                        luck: update.world.luck,
                        mainHandItemInstanceID: (_e = update.world.mainHandItemInstance) === null || _e === void 0 ? void 0 : _e.itemInstanceID,
                        maskItemInstanceID: (_f = update.world.maskItemInstance) === null || _f === void 0 ? void 0 : _f.itemInstanceID,
                        offHandItemInstanceID: (_g = update.world.offHandItemInstance) === null || _g === void 0 ? void 0 : _g.itemInstanceID,
                        outfitItemInstanceID: (_h = update.world.outfitItemInstance) === null || _h === void 0 ? void 0 : _h.itemInstanceID,
                        strength: update.world.strength,
                        timePlayed: update.world.timePlayed,
                        wisdom: update.world.wisdom,
                        worldCharacterID: update.world.characterID,
                    });
                    state_1.state.setValues({
                        worldState,
                    });
                    for (const worldCharacterUpdate of update.world.characters) {
                        (0, loadWorldCharacterUpdate_1.loadWorldCharacterUpdate)(worldCharacterUpdate);
                    }
                    for (const npcUpdate of update.world.npcs) {
                        (0, loadWorldNPCUpdate_1.loadWorldNPCUpdate)(npcUpdate);
                    }
                    for (const bagItemInstanceUpdate of update.world.bagItemInstances) {
                        (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(bagItemInstanceUpdate);
                    }
                    for (const boostItemInstanceUpdate of update.world
                        .boostItemInstances) {
                        (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(boostItemInstanceUpdate);
                    }
                    if (typeof update.world.bodyItemInstance !== "undefined") {
                        (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.world.bodyItemInstance);
                    }
                    if (typeof update.world.headItemInstance !== "undefined") {
                        (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.world.headItemInstance);
                    }
                    if (typeof update.world.mainHandItemInstance !== "undefined") {
                        (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.world.mainHandItemInstance);
                    }
                    if (typeof update.world.offHandItemInstance !== "undefined") {
                        (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.world.offHandItemInstance);
                    }
                    if (typeof update.world.clothesDyeItemInstance !== "undefined") {
                        (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.world.clothesDyeItemInstance);
                    }
                    if (typeof update.world.hairDyeItemInstance !== "undefined") {
                        (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.world.hairDyeItemInstance);
                    }
                    if (typeof update.world.maskItemInstance !== "undefined") {
                        (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.world.maskItemInstance);
                    }
                    if (typeof update.world.outfitItemInstance !== "undefined") {
                        (0, loadItemInstanceUpdate_1.loadItemInstanceUpdate)(update.world.outfitItemInstance);
                    }
                    (0, selectWorldCharacter_1.selectWorldCharacter)(update.world.characterID);
                    break;
                }
            }
            (0, listenForMainMenuUpdates_1.listenForMainMenuUpdates)();
            (0, listenForWorldUpdates_1.listenForWorldUpdates)();
            (0, pixel_pigeon_1.listenToSocketioEvent)({
                event: "legacy/open-emotes",
                onMessage: () => {
                    if (emotesWorldMenu_1.emotesWorldMenu.isOpen() === false) {
                        (0, closeWorldMenus_1.closeWorldMenus)();
                        emotesWorldMenu_1.emotesWorldMenu.open({});
                    }
                },
            });
            (0, pixel_pigeon_1.listenToSocketioEvent)({
                event: "legacy/open-stats",
                onMessage: () => {
                    if (statsWorldMenu_1.statsWorldMenu.isOpen() === false) {
                        (0, closeWorldMenus_1.closeWorldMenus)();
                        statsWorldMenu_1.statsWorldMenu.open({});
                    }
                },
            });
            (0, pixel_pigeon_1.listenToSocketioEvent)({
                event: "legacy/open-quest-log",
                onMessage: () => {
                    if (questLogWorldMenu_1.questLogWorldMenu.isOpen() === false) {
                        (0, closeWorldMenus_1.closeWorldMenus)();
                        questLogWorldMenu_1.questLogWorldMenu.open({});
                    }
                },
            });
            (0, pixel_pigeon_1.listenToSocketioEvent)({
                event: "legacy/open-spellbook",
                onMessage: () => {
                    if (spellbookWorldMenu_1.spellbookWorldMenu.isOpen() === false) {
                        (0, closeWorldMenus_1.closeWorldMenus)();
                        spellbookWorldMenu_1.spellbookWorldMenu.open({});
                    }
                },
            });
            (0, pixel_pigeon_1.listenToSocketioEvent)({
                event: "legacy/open-inventory",
                onMessage: () => {
                    if (inventoryWorldMenu_1.inventoryWorldMenu.isOpen() === false) {
                        (0, closeWorldMenus_1.closeWorldMenus)();
                        inventoryWorldMenu_1.inventoryWorldMenu.open({});
                    }
                },
            });
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "party-change",
        onMessage: (update) => {
            for (const partyUpdate of update.parties) {
                const oldPartyPlayerIDs = (0, definables_1.definableExists)(Party_1.Party, partyUpdate.partyID)
                    ? (0, definables_1.getDefinable)(Party_1.Party, partyUpdate.partyID).playerIDs
                    : [];
                (0, loadPartyUpdate_1.loadPartyUpdate)(partyUpdate);
                const party = (0, definables_1.getDefinable)(Party_1.Party, partyUpdate.partyID);
                for (const player of party.players) {
                    player.character.partyID = partyUpdate.partyID;
                }
                if (typeof update.world !== "undefined") {
                    const worldState = (0, getWorldState_1.getWorldState)();
                    party.players.forEach((partyPlayer, partyPlayerIndex) => {
                        const partyWorldCharacterJoined = oldPartyPlayerIDs.includes(partyPlayer.id) === false;
                        const partyWorldCharacterIsSelf = partyPlayer.worldCharacterID ===
                            worldState.values.worldCharacterID;
                        if ((partyWorldCharacterIsSelf &&
                            selectedPlayerWorldMenu_1.selectedPlayerWorldMenu.isOpen()) ||
                            state_1.state.values.selectedPlayerID === partyPlayer.id) {
                            selectedPlayerWorldMenu_1.selectedPlayerWorldMenu.close();
                        }
                        // If self is joining a party
                        if (partyPlayerIndex > 0 &&
                            partyWorldCharacterJoined &&
                            partyWorldCharacterIsSelf) {
                            worldState.setValues({
                                pianoSessionID: null,
                            });
                            (0, definables_1.getDefinables)(WorldCharacter_1.WorldCharacter).forEach((worldCharacter) => {
                                if (worldCharacter.hasMarkerEntity()) {
                                    (0, clearWorldCharacterMarker_1.clearWorldCharacterMarker)(worldCharacter.id);
                                }
                            });
                        }
                        else if (party.playerIDs.length > oldPartyPlayerIDs.length) {
                            if (partyPlayer.worldCharacter.hasMarkerEntity()) {
                                (0, clearWorldCharacterMarker_1.clearWorldCharacterMarker)(partyPlayer.worldCharacter.id);
                            }
                        }
                    });
                    (0, resetParty_1.resetParty)(party.id);
                }
            }
            for (const partyIDToRemove of update.partyIDsToRemove) {
                (0, definables_1.getDefinable)(Party_1.Party, partyIDToRemove).remove();
            }
            if (typeof update.world !== "undefined") {
                for (const worldPartyCharacterUpdate of update.world.characters) {
                    (0, loadWorldPartyCharacterUpdate_1.loadWorldPartyCharacterUpdate)(worldPartyCharacterUpdate);
                }
            }
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "remove-player",
        onMessage: (update) => {
            const player = (0, definables_1.getDefinable)(Player_1.Player, update.playerID);
            if (state_1.state.values.selectedPlayerID === update.playerID) {
                selectedPlayerWorldMenu_1.selectedPlayerWorldMenu.close();
            }
            if (player.hasWorldCharacter()) {
                (0, exitWorldCharacters_1.exitWorldCharacters)([player.worldCharacterID]);
            }
            player.remove();
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "rename-player",
        onMessage: (update) => {
            const player = (0, definables_1.getDefinable)(Player_1.Player, update.playerID);
            player.username = update.username;
        },
    });
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "turn-in-quest",
        onMessage: (update) => {
            var _a, _b;
            const worldState = (0, getWorldState_1.getWorldState)();
            const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldState.values.worldCharacterID);
            const previousLevel = worldCharacter.player.character.level;
            for (const playerUpdate of update.players) {
                const player = (0, definables_1.getDefinable)(Player_1.Player, playerUpdate.playerID);
                player.character = {
                    classID: player.character.classID,
                    level: playerUpdate.level,
                    partyID: player.character.partyID,
                };
            }
            const didLevelUp = worldCharacter.player.character.level !== previousLevel;
            if (typeof update.world !== "undefined") {
                const worldUpdate = update.world;
                const isLeader = worldCharacter.player.character.party.playerIDs[0] ===
                    worldCharacter.playerID;
                if (npcDialogueWorldMenu_1.npcDialogueWorldMenu.isOpen() === false) {
                    (0, closeWorldMenus_1.closeWorldMenus)();
                    npcDialogueWorldMenu_1.npcDialogueWorldMenu.open({
                        isLeader,
                        npcID: worldUpdate.npcID,
                    });
                }
                for (const worldCharacterUpdate of worldUpdate.characters) {
                    const partyWorldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldCharacterUpdate.characterID);
                    partyWorldCharacter.resources = {
                        hp: worldCharacterUpdate.resources.hp,
                        maxHP: worldCharacterUpdate.resources.maxHP,
                        maxMP: (_a = worldCharacterUpdate.resources.maxMP) !== null && _a !== void 0 ? _a : null,
                        mp: (_b = worldCharacterUpdate.resources.mp) !== null && _b !== void 0 ? _b : null,
                    };
                }
                const npc = (0, definables_1.getDefinable)(NPC_1.NPC, worldUpdate.npcID);
                npcDialogueWorldMenu_1.npcDialogueWorldMenu.state.setValues({
                    selectedQuestIndex: typeof worldUpdate.questID !== "undefined"
                        ? npc.questGiver.quests.findIndex((questGiverQuest) => questGiverQuest.questID === worldUpdate.questID)
                        : null,
                });
                const quest = (0, definables_1.getDefinable)(Quest_1.Quest, worldUpdate.questID);
                for (const partyPlayer of worldCharacter.player.character.party
                    .players) {
                    const questInstance = partyPlayer.worldCharacter.questInstances[worldUpdate.questID];
                    if (typeof questInstance !== "undefined") {
                        if ((0, canWorldCharacterTurnInQuest_1.canWorldCharacterTurnInQuest)(partyPlayer.worldCharacterID, quest.id)) {
                            if (questInstance.isCompleted === false) {
                                npcDialogueWorldMenu_1.npcDialogueWorldMenu.state.setValues({
                                    questCompletion: {
                                        didLevelUp,
                                        questID: quest.id,
                                    },
                                    selectedQuestIndex: null,
                                });
                                questInstance.isCompleted = true;
                            }
                        }
                    }
                }
                worldState.setValues({
                    experienceUntilLevel: worldUpdate.experienceUntilLevel,
                });
            }
        },
    });
};
exports.listenForUpdates = listenForUpdates;
